import React from 'react';
import { Link } from 'react-router-dom';
import { useCityContext } from '../../context/CityContext';
import './Footer.css';

export default function Footer() {
  const { activeCity } = useCityContext();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo-mark">
            {activeCity ? activeCity.name.charAt(0) : 'N'}
          </div>
          <div>
            <div className="footer-app-name">
              Notify {activeCity ? activeCity.name : 'Cities'}
            </div>
            <div className="footer-sub">Stay informed. Stay prepared.</div>
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-link-group">
            <div className="footer-link-heading">Platform</div>
            <Link to="/" className="footer-link">All Cities</Link>
            <Link to="/admin" className="footer-link">Admin Config</Link>
          </div>
          {activeCity && (
            <div className="footer-link-group">
              <div className="footer-link-heading">{activeCity.name}</div>
              <Link to={`/${activeCity.slug}`} className="footer-link">Browse Alerts</Link>
              <Link to={`/${activeCity.slug}/my-alerts`} className="footer-link">My Notifications</Link>
            </div>
          )}
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Notify Cities Platform</span>
        <span className="footer-bottom-sub">Built for every city, one config at a time.</span>
      </div>
    </footer>
  );
}
